import { DataHeader, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutZoneRegion extends Layout {
    dataheaderZoneRegion: DataHeader;
    panelZoneRegion: Panel;
    sourceZoneRegion: DataSource;
    textboxDescription: Textbox;
    textboxId: Textbox;
    textboxZonesuperregionId: Textbox;
}
